import { api } from '../api';
import { CategoryItem } from '../../interfaces/components/chatList';
import http from '../http';
import { GetTabCategoriesResponse, TabResponse } from '../../interfaces/api/tabs';

/**
 * API services for tab management
 * Provides methods to retrieve tabs and their associated categories
 */
export const tabs = {
  /**
   * Retrieves all available tabs
   * @returns {Promise<TabResponse>} Promise resolving to the tabs response containing tab data
   */
  getAll: (): Promise<TabResponse> =>
    new Promise((resolve, reject) => {
      http
        .get(api.tabs.getAll)
        .then((res) => resolve(res as TabResponse))
        .catch((e) => reject(e));
    }),

  /**
   * Retrieves categories for a specific tab
   * @param {number} tabId - The ID of the tab to retrieve categories for
   * @returns {Promise<CategoryItem[]>} Promise resolving to an array of category items
   */
  getCategories: (tabId: number): Promise<CategoryItem[]> =>
    new Promise((resolve, reject) => {
      http
        .get(api.tabs.categories(tabId))
        .then((res) => {
          const response = res as GetTabCategoriesResponse;
          resolve(response?.data || []);
        })
        .catch((e) => reject(e));
    }),
};
